export default __webpack_public_path__ + "static/media/lt.54744b97.jpg";